module.exports = __webpack_public_path__ + "static/img/wispNesalMask.01704d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maskPng/wispNesalMask.png
// module id = w7mJ
// module chunks = 1